import $ from 'jquery';
import { FOCUSED_CLASSNAME } from './contants';
export function getSelectorByKeywords(keywordOnAttr) {
    return `[data-keyword="${encodeURI(keywordOnAttr)}"]`;
}
;
function focus(element, bol = false) {
    const classes = element.classList;
    if (element.siblings) {
        element.siblings.forEach(ele => focus(ele, bol));
    }
    if (bol === true) {
        classes.add(FOCUSED_CLASSNAME);
    }
    else if (bol === false) {
        classes.remove(FOCUSED_CLASSNAME);
    }
    return classes.contains(FOCUSED_CLASSNAME);
}
export function getNodeArrayByValue(keyword) {
    let selector = getSelectorByKeywords(keyword);
    selector += ':visible';
    const nodes = $(selector).toArray();
    let group = [];
    nodes.forEach(node => {
        group.push([node]);
    });
    const items = group
        .filter(items => items.length > 0)
        .map(([item, ...siblings]) => {
        item.siblings = siblings || [];
        return item;
    });
    items.forEach(ele => {
        if (focus(ele)) {
            focus(ele, false);
        }
    });
    return items;
}
/*!
 * Check if an element is out of the viewport
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}  elem The element to check
 * @return {Object}     A set of booleans for each side of the element
 */
export function isOutOfViewport(elem) {
    // Get element's bounding
    const bounding = elem.getBoundingClientRect();
    // Check if it's out of the viewport on each side
    let out = {};
    out.top = bounding.top < 0;
    out.left = bounding.left < 0;
    out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
    out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
    out.any = out.top || out.left || out.bottom || out.right;
    out.all = out.top && out.left && out.bottom && out.right;
    return out;
}
export const Store = (prefix = 'analytics') => ({
    get(key, defaultValue) {
        const lKey = `${prefix}:${key}`;
        const value = localStorage.getItem(lKey) || '';
        try {
            return JSON.parse(value);
        }
        catch (e) {
            this.remove(lKey);
            return defaultValue;
        }
    },
    set(key, value) {
        localStorage.setItem(`${prefix}:${key}`, JSON.stringify(value));
        return this;
    },
    remove(key) {
        localStorage.removeItem(`${prefix}:${key}`);
        return this;
    }
});
//# sourceMappingURL=utils.js.map